export default __webpack_public_path__ + "static/media/header_mobile_menu_clicked.944b7f29.svg";